import { Box } from '@mui/material';
import { SectionTitle, SectionContent, HighlightedText } from './LeaseTextPrimitives';

export const UTILITIES_MAP = {
  electricity: 'Electricity',
  heat: 'Heat',
  water_waste: 'Water/Waste',
};

/** Utilities the tenant is responsible for, i.e. those NOT included in rent. */
export const getNotIncludedUtilities = (utilitiesAvailable) =>
  Object.entries(utilitiesAvailable || {})
    .filter(([, isIncluded]) => !isIncluded)
    .map(([key]) => UTILITIES_MAP[key]);

export const formatList = (items) => {
  if (!items?.length) return 'None';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
};

/**
 * Clause 7, the single canonical version rendered by all five lease views.
 *
 * The tenant-signing consent checkbox is deliberately NOT part of this component:
 * it is interactive and gates submission, so the signing views pass it as `footer`.
 */
export const UtilitiesClause = ({ utilitiesString, notIncludedUtilities = [], customUtilitiesClause = '', footer = null }) => (
  <Box className="section">
    <SectionTitle>7. UTILITIES AND SERVICE</SectionTitle>
    <SectionContent highlighted>
      <div className="pb-2">
        The tenant agrees to pay, as and when due, all charges for the following utilities and services for{' '}
        <HighlightedText>{utilitiesString}</HighlightedText>.
      </div>

      {notIncludedUtilities.length > 0 && (
        <>
          <div className="pb-2">
            Service Provider Account # must be provided to Management at the time of moving in.
          </div>

          <div className="pb-2">
            <span className="text-black fw-bold">Utility Account Responsibility:</span> If the tenant fails to establish any required utility account in their name, or if the landlord is required to pay a utility on the tenant’s behalf:
            <br />
            The tenant shall reimburse the actual utility costs plus an administrative fee of <HighlightedText>$150.00</HighlightedText> per utility account not properly set up.
          </div>

          <div>
            <span className="text-black fw-bold">Consequences of Non-Compliance:</span> If this amount is not collected during the tenancy, it may constitute grounds for eviction. Any outstanding amounts will be assessed during the <HighlightedText>Statement of Account (SOA)</HighlightedText> process, at which time an administrative fee of <HighlightedText>$300.00</HighlightedText> per utility account not set up will apply.
          </div>
        </>
      )}

      {notIncludedUtilities.length === 0 && (
        <div className="pb-2">
          All utilities included in rent – no separate accounts required.
        </div>
      )}

      {/* Property-specific wording configured per building in Edit Property. */}
      {!!customUtilitiesClause?.trim() && (
        <div className="pt-2" style={{ whiteSpace: 'pre-wrap' }}>
          {customUtilitiesClause}
        </div>
      )}
    </SectionContent>

    {footer}
  </Box>
);

export default UtilitiesClause;
